var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDice5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M440.89 0H71.11C31.854.047.046 31.855 0 71.11v369.78c.047 39.255 31.855 71.063 71.11 71.11h369.78c39.255-.047 71.063-31.855 71.11-71.11V71.11C511.953 31.854 480.145.046 440.89 0zm42.665 440.89c-.024 23.551-19.114 42.641-42.664 42.665H71.109c-23.55-.024-42.64-19.114-42.664-42.664V71.109C28.47 47.56 47.56 28.47 71.11 28.445h369.782c23.55.024 42.64 19.114 42.664 42.664zm0 0",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.668 256c0 23.563-19.105 42.668-42.668 42.668S213.332 279.562 213.332 256s19.106-42.668 42.668-42.668 42.668 19.105 42.668 42.668zM426.668 384c0 23.563-19.105 42.668-42.668 42.668S341.332 407.562 341.332 384s19.106-42.668 42.668-42.668 42.668 19.106 42.668 42.668zM170.668 384c0 23.563-19.106 42.668-42.668 42.668S85.332 407.562 85.332 384s19.106-42.668 42.668-42.668 42.668 19.106 42.668 42.668zM426.668 128c0 23.563-19.105 42.668-42.668 42.668S341.332 151.562 341.332 128 360.438 85.332 384 85.332s42.668 19.106 42.668 42.668zM170.668 128c0 23.563-19.106 42.668-42.668 42.668S85.332 151.562 85.332 128 104.438 85.332 128 85.332s42.668 19.106 42.668 42.668zm0 0",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDice5);
export default __webpack_public_path__ + "static/media/dice5.29be46792def1e0b8c3e27740beed0d6.svg";
export { ForwardRef as ReactComponent };